export default {
  getCsrfToken: () => {
    const name = document
      .querySelector('meta[name="csrfTokenName"]')
      .getAttribute("content");

    const token = document
      .querySelector('meta[name="csrfToken"]')
      .getAttribute("content");

    return { [name]: token };
  },
};
